module.exports = __webpack_public_path__ + "static/media/brand22.cce85331.png";